<template>
    <div class="float-right">
        <span style="font-size: 16px" class="p-0">
            <a href="#" @click="decrement()">
                <i class="fas fa-chevron-square-left mr-2 mt-0 mb-0"></i>
            </a>
            Semaine du {{ start | moment('Do MMMM') }} au
            {{ end | moment('Do MMMM Y') }}
            <a href="#" @click="increment()">
                <i class="fas fa-chevron-square-right ml-2 mt-0 mb-0"></i>
            </a>
        </span>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import DataUpdater from '../../../dashboard/mixins/DataUpdater'

export default {
    name: 'WeekHandler',

    mixins: [DataUpdater],

    props: {
        next: '',
        prev: '',
        start: '',
        end: '',
    },

    methods: {
        increment() {
            this.$store.commit('timeSheetsVM/SET_CURRENT_DATE', this.next)
            this.$emit('week-has-changed')
            // this.updateData()
        },

        decrement() {
            this.$store.commit('timeSheetsVM/SET_CURRENT_DATE', this.prev)
            this.$emit('week-has-changed')
            // this.updateData()
        },
    },
}
</script>

<style scoped></style>
